import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map, Observable } from 'rxjs';
import { BadgeApi } from '../api/badge.api';
import { BadgeCategories } from '../../../models/badge.model';
import { AbstractFacade } from './abstract.facade';


export class BadgesState {
  badges: BadgeCategories;
  loading: boolean;
  loaded: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class BadgesFacade extends AbstractFacade {
  private state: BadgesState = {
    badges: [],
    loading: false,
    loaded: false,
  };
  public readonly store = new BehaviorSubject<BadgesState>(this.state);
  public readonly state$ = this.store.asObservable();
  public readonly badges$ = this.state$.pipe(map(state => state.badges), distinctUntilChanged());
  public readonly loading$ = this.state$.pipe(map(state => state.loading), distinctUntilChanged());
  public readonly loaded$ = this.state$.pipe(map(state => state.loaded), distinctUntilChanged());

  constructor(private readonly badgeApi: BadgeApi) {
    super();
  }

  getState$(): Observable<BadgesState> {
    return this.state$;
  }

  private setState(newState: Partial<BadgesState>) {
    this.state = {...this.state, ...newState };
    this.store.next(this.state);
  }

  loadBadges(userId: number) {
    this.setState({
      loading: true,
    });
    this.badgeApi.getUserBadges(userId).subscribe({
        next: (badgesByCategories) => {
          this.setState({
            badges: badgesByCategories,
            loading: false,
            loaded: true
          });
        },
        error: () => {
          console.error('Unable to load badges');
          this.setState({
            loaded: false,
            loading: false,
          });
        }
      });
  }

  isLoaded() {
    return this.state.loaded;
  }

  isLoading() {
    return this.state.loading;
  }
}
